import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app")({
	component: Page,
	beforeLoad: async ({ context, location }) => {
		const user = context.session.user;

		if (!user) {
			throw redirect({
				to: "/auth/login",
				search: { redirect: location.pathname },
			});
		}

		return {
			user,
		};
	},
});

function Page() {
	return <Outlet />;
}
